<ng-container *ngIf="!isInCarousel; else notEditable">
  <h1
    *ngIf="contentlet.bannerTitle"
    class="mb-2 text-6xl font-bold text-shadow"
    [ngStyle]="{ color: contentlet?.textColor }"
    [class]="animationCss"
  >
    <custom-dot-editable-text fieldName="bannerTitle" [mode]="'minimal'" [format]="'html'" [contentlet]="contentlet" />
  </h1>
  <p *ngIf="contentlet.caption" [class]="animationCss" [ngStyle]="{ color: contentlet?.textColor }">
    <custom-dot-editable-text fieldName="caption" [mode]="'minimal'" [format]="'html'" [contentlet]="contentlet" />
  </p>
  <ng-container *ngIf="contentlet?.buttonText && contentlet?.link">
    <a
      [class]="animationCss"
      class="btn btn-primary button-leaf"
      [style.backgroundColor]="contentlet?.buttonColor"
      [ngStyle]="{ color: contentlet?.textColor }"
      (click)="selectPromotionGTMEvent()"
    >
      <div class="hover-border-top" [style.backgroundColor]="contentlet?.buttonColor"></div>
      <div class="link-text">{{ this.contentlet.buttonText }}</div>
      <div class="hover-border-bottom" [style.backgroundColor]="contentlet?.buttonColor"></div>
    </a>
  </ng-container>
</ng-container>

<ng-template #notEditable>
  <h1
    *ngIf="contentlet.bannerTitle"
    [class]="animationCss"
    [ngStyle]="{ color: contentlet?.textColor }"
    [ishServerHtml]="contentlet.bannerTitle"
  ></h1>
  <p *ngIf="contentlet.caption" [class]="animationCss">
    <span [ngStyle]="{ color: contentlet?.textColor }" [ishServerHtml]="contentlet.caption"> </span>
  </p>
  <ng-container *ngIf="contentlet?.buttonText && contentlet?.link">
    <a
      [class]="animationCss"
      class="btn btn-primary button-leaf"
      [style.backgroundColor]="contentlet?.buttonColor"
      [ngStyle]="{ color: contentlet?.textColor }"
      (click)="selectPromotionGTMEvent()"
    >
      <div class="hover-border-top" [style.backgroundColor]="contentlet?.buttonColor"></div>
      <div class="link-text">{{ this.contentlet.buttonText }}</div>
      <div class="hover-border-bottom" [style.backgroundColor]="contentlet?.buttonColor"></div>
    </a>
  </ng-container>
</ng-template>
